import { userRole } from '@/Constants/roles';
import router from '@/router';
import { useStoreMeta } from '@/Store/storeMeta';

export function roleCheck(allowedRoles: Array<userRole>) {
    console.log(useStoreMeta().role);
    if (allowedRoles.includes(useStoreMeta().role)) {
        return true;
    }

    console.warn('Нет роли');

    return false;
}
